import { axios } from "../../helper/axios";
import { CheckIncustomerConstant } from "./CheckInCustomerConstant";

const CheckIncustomerApi = {};

CheckIncustomerApi.getCheckIncustomerData = ({
  chargingStation = "",
  model = "",
  connector = "",
  manufacturer = "",
  startDate,
  endDate,
  search,
  page = 1,
  limit,
  filter
}) => {
  const params = {
    chargingStation: chargingStation === "All" ? "" : chargingStation,
    model: model === "All" ? "" : model,
    connector: connector === "All" ? "" : connector,
    manufacturer: manufacturer === "All" ? "" : manufacturer,
    filter,
    startDate,
    endDate,
    search,
    page,
    limit
  };

  const queryParams = new URLSearchParams();

  for (const key in params) {
    if (params[key]) {
      queryParams.append(key, params[key]);
    }
  }

  return axios.get(`${CheckIncustomerConstant.CHECKIN_CUSTOMER_API}?${queryParams.toString()}`);
};


// export bulk data 
CheckIncustomerApi.getCheckInBulkExportcustomerData = ({
 
  limit
}) => {
  let qeuryParam ='';
 
 if( limit){
   qeuryParam = `?pageSize=${limit}`;

 }
 

  return axios.get(`${CheckIncustomerConstant.CHECKIN_CUSTOMER_API}${qeuryParam}`);
};





CheckIncustomerApi.AddCheckinCostomerApi = (payload) => {

  return axios.post(CheckIncustomerConstant.ADD_CHECKIN_CUSTOMER_DETAIL_API, payload);
};
CheckIncustomerApi.checkinCustomerbyId = ( id ) => {

  return axios.get(
    `${CheckIncustomerConstant.CHECKIN_CUSTOMER_DETAILS_BY_ID_API}/${id}`
  );
};
CheckIncustomerApi.checkinsearchNavigtionbyId = ( id ) => {
  
  return axios.get(
    `${CheckIncustomerConstant.CHECKIN_SEARCH_NAVIGATION_BY_ID_API}/${id}`
  );
};
CheckIncustomerApi.checkinsearchSearchHistorybyId = ( id ) => {
  
  return axios.get(
    `${CheckIncustomerConstant.CHECKIN_SEARCH_HISTORY_BY_ID_API}/${id}`
  );
};
CheckIncustomerApi.checkinVehiclesbyId = ( id ) => {
  
  return axios.get(
    `${CheckIncustomerConstant.CHECKIN_VEHICLE_BY_ID_API}/${id}`
  );
};
CheckIncustomerApi.checkinChargingHistorybyId = ( id ) => {
  
  return axios.get(
    `${CheckIncustomerConstant.CHECKIN_CHARGING_HISTORY_BY_ID_API}/${id}`
  );
};
CheckIncustomerApi.CustomerbyId = ( id ) => {
  return axios.get(
    `${CheckIncustomerConstant.CUSTOMER_DETAILS_BY_ID_API}/${id}`
  );
};

export { CheckIncustomerApi };
